import { createStore } from 'redux';
import Reducer from './Reducer';

const mainStore = createStore(Reducer);

export default mainStore;